import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  reduce, orderBy, filter,
  each, map, values, keyBy,
} from 'lodash';
import { connect } from 'react-redux';
import Toggle from 'react-bootstrap-toggle';
import { Button } from 'react-bootstrap';
import hashObject from 'object-hash';

import Fa from 'react-fontawesome';
import AccountNameRenderer from '../../../../components/table-cells/AccountNameRenderer';
import OpportunityNameRenderer from '../../../../components/table-cells/OpportunityNameRenderer';
import LogRenderer from '../../../../components/table-cells/LogRenderer';
import FeedbackRenderer from './cells/FeedbackRenderer';
import SurveyRenderer from './cells/SurveyRenderer';
import CompetitorRenderer from './cells/CompetitorRenderer';
import PublishDateRenderer from './cells/PublishDateRenderer';
import StageLogRenderer from '../../../../components/table-cells/StageLogRenderer';
import DetailRenderer from './DetailRenderer';
import PricePositionRenderer from './cells/MasterPricePositionRenderer';
import ModalDetail from './ModalDetail';
// import createRequestFeedbackComponent, { OPPORTUNITY_COMPONENT_TYPE } from './RequestOpportunityFeedbacks';

import { getUser } from '../../../Auth/AuthReducer';
import { getTablePreference } from '../../../App/AppReducer';
import {
  dateComparator, stringComparator,
} from '../../../../components/table-cells/helpers';
import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import {
  requestEditWinLossOpportunityFeedbacks,
  fetchInsights,
  requestShowSurveyEmail,
} from '../../DashboardActions';
import { getWinLossCollectorStats } from '../../DashboardReducer';
import NumberDisplay from '../../../../components/number-display';
import SaleRepsNameRenderer from '../../../../components/table-cells/SaleRepsNameRenderer';

const STAGE_COLUMN = '___STAGE___';
const OWNER_COLUMN = '___ONWER___';
const HAS_FEEDBACK_COLUMN = '___HAS_FEEDBACKS___';
const IN_OUTREACH_COLUMN = '___IN_OUTREACH_COLUMN___';
const NEED_REASONS_COLUMN = '___NEED_REASONS_COLUMN___';
const HAS_REFUSED_COLUMN = '___HAS_REFUSED_COLUMN___';
const HAS_NON_RESPONSIVE_COLUMN = '___HAS_NON_RESPONSIVE_COLUMN___';

const MODE_SURVEYS = 'surveys';
const MODE_FEEDBACKS = 'feedbacks';

const NESTED_MODE = false;

const EXTRA_FIELDS = [
  { id: STAGE_COLUMN, field: 'stage' },
  { id: HAS_FEEDBACK_COLUMN, field: 'has_feedbacks' },
  { id: IN_OUTREACH_COLUMN, field: 'in_outreach' },
  { id: NEED_REASONS_COLUMN, field: 'need_reasons' },
  { id: HAS_REFUSED_COLUMN, field: 'has_refused' },
  { id: HAS_NON_RESPONSIVE_COLUMN, field: 'has_non_responsive' },
];

// const RequestOpportunityFeedbacks = createRequestFeedbackComponent(OPPORTUNITY_COMPONENT_TYPE);

class OpportunityTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllDeals: true,
      detailModes: {},
      expandedRows: 0,
      hashedFilters: null,
      detailModal: {},
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.toggleShowAllDeals = this.toggleShowAllDeals.bind(this);
    this.hanldeRequestAddOpportunitySurvey = this.hanldeRequestAddOpportunitySurvey.bind(this);
    this.onColumnResized = this.onColumnResized.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.hanldeRequestShowEmail = this.hanldeRequestShowEmail.bind(this);
    this.handleOnSubmitContacts = this.handleOnSubmitContacts.bind(this);
    this.handleGroupExpandedOrCollapsed = this.handleGroupExpandedOrCollapsed.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.getOutcomeValue = this.getOutcomeValue.bind(this);
    this.feedbackDateKeyCreator = this.feedbackDateKeyCreator.bind(this);
    this.feedbackValueFormatter = this.feedbackValueFormatter.bind(this);
    this.footerValueGetter = this.footerValueGetter.bind(this);
    this.getCompetitorValue = this.getCompetitorValue.bind(this);
    this.getOutcomeReasonValue = this.getOutcomeReasonValue.bind(this);
    this.getFeedbackCellRendererSelector = this.getFeedbackCellRendererSelector.bind(this);
    this.getCompetitorOutcomeCellRendererSelector = this.getCompetitorOutcomeCellRendererSelector.bind(this);
    this.handleRequestShowDetail = this.handleRequestShowDetail.bind(this);
    this.outcomeKeyCreator = this.outcomeKeyCreator.bind(this);
    this.outcomeComparator = this.outcomeComparator.bind(this);
    this.competitorKeyCreator = this.competitorKeyCreator.bind(this);
    this.competitorComparator = this.competitorComparator.bind(this);
    this.handleSubmitContactAndDone = this.handleSubmitContactAndDone.bind(this);
    this.getPricePositionValue = this.getPricePositionValue.bind(this);
    this.pricePositionKeyCreator = this.pricePositionKeyCreator.bind(this);
    this.reaplyFilters = this.reaplyFilters.bind(this);
    this.getExcluedReasonValue = this.getExcluedReasonValue.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.gridApi && !this.props.feedbackLoaded && nextProps.feedbackLoaded) {
      this.gridApi.resetRowHeights();
    }
    if (nextProps.feedbackLoaded) {
      this.applyFilters(nextProps.opportunityFilters);
    }
  }

  onGridReady(params) {
    const { isManager, auth } = this.props;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.applyFilters(this.props.opportunityFilters);
    if (!isManager) {
      this.setOwnerFilter(auth.user_id);
    }
    if (this.props.feedbackLoaded) {
      this.gridApi.resetRowHeights();
      this.applyFilters(this.props.opportunityFilters, true);
    }
  }

  onColumnResized() {
    if (this.gridApi) {
      this.gridApi.resetRowHeights();
    }
    this.applyFilters(this.props.opportunityFilters, true);
  }

  getCloseDateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'close_date',
      sort: 'desc',
      type: 'dateColumn',
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: LogRenderer,
          params: {
            field: 'close_date',
          },
        };
      },
      enableRowGroup: true,
      cellRendererParams: {
        isCloseDate: true,
        column,
      },
      valueGetter: (params) => {
        if (params && params.data) {
          return moment(params.data.close_date).format('YYYY-MM-DD');
        }
        return null;
      },
      keyCreator: (params) => {
        const vals = params.value;
        if (!vals) {
          return '--';
        }
        let format = 'Y \\QQ';
        if (this.state.closeDateGroupingType === 'quarterly') {
          format = 'Y \\QQ';
        } else if (this.state.closeDateGroupingType === 'monthly') {
          format = 'Y MM';
        } else if (this.state.closeDateGroupingType === 'yearly') {
          format = 'Y';
        }
        return moment(vals, 'YYYY-MM-DD').format(format);
      },
      valueFormatter: (params) => {
        if (params.value) {
          let format = 'Y \\QQ';
          let displayFormat = '\\QQ Y';
          if (this.state.closeDateGroupingType === 'quarterly') {
            format = 'Y \\QQ';
            displayFormat = '\\QQ Y';
          } else if (this.state.closeDateGroupingType === 'monthly') {
            format = 'Y MM';
            displayFormat = 'MMMM Y';
          } else if (this.state.closeDateGroupingType === 'yearly') {
            format = 'Y';
            displayFormat = 'Y';
          }
          return moment(`${params.value}`, format).format(displayFormat);
        }
        return params.value;
      },
    };
  }

  getAccountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      rowDrag: true,
      enablePivot: true,
      enableRowGroup: true,
      field: 'account.name',
      cellRendererParams: {
        exportURLType: 'account',
      },
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: AccountNameRenderer,
          params: {
            enableAutoHeight: true,
            column,
            ellipsis: true,
            exportURLType: 'account',
          },
        };
      },
    };
  }

  getOwnerColumn(column, isAccountOwner = false) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      rowDrag: true,
      enablePivot: true,
      enableRowGroup: true,
      field: isAccountOwner ? 'account.owner.name' : 'owner.name',
      cellRendererParams: {
        exportURLType: 'owner',
      },
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: SaleRepsNameRenderer,
          params: {
            enableAutoHeight: true,
            column,
            isAccountOwner,
            exportURLType: 'owner',
          },
        };
      },
    };
  }

  getNameColumn(column) {
    return {
      colId: column._id,
      headerName: 'Opportunity',
      width: column.width,
      hide: !column.is_visible,
      field: 'name',
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      cellRenderer: OpportunityNameRenderer,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
        exportURLType: 'opportunity',
      },
    };
  }

  getAmountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'amount',
      type: 'numericColumn',
      cellRenderer: LogRenderer,
      cellRendererParams: {
        field: 'amount',
        column,
      },
      enableValue: true,
      allowedAggFuncs: ['sum', 'min', 'max', 'avg'],
    };
  }

  getStageColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'stage',
      enablePivot: true,
      enableRowGroup: true,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
      // valueGetter: this.getOutcomeValue,
      // keyCreator: this.outcomeKeyCreator,
      comparator: this.outcomeComparator,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: StageLogRenderer,
          params: {
            field: 'outcome',
            logField: 'stage_name',
          },
        };
      },
    };
  }

  getPricePositionValue(params) {
    const { colDef: { field } } = params;
    if (field && params.data && params.data[field]) {
      return map(params.data[field], 'label');
    }
    return null;
  }

  getExcluedReasonValue(params) {
    if (params.data && params.data.exclusion) {
      return (params.data.exclusion.reason || null);
    }
    return '';
  }

  getPricePositionColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'price_positions',
      enablePivot: false,
      enableRowGroup: true,
      ...(column.auto_height ? { cellClass: 'cell-wrap-text' } : {}),
      autoHeight: column.auto_height,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
        field: 'price_positions',
        mode: MODE_FEEDBACKS,
        requestShowFeedback: this.handleRequestShowDetail,
      },
      valueGetter: this.getPricePositionValue,
      keyCreator: this.pricePositionKeyCreator,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: PricePositionRenderer,
          params: {
            field: 'price_positions',
            mode: MODE_FEEDBACKS,
            requestShowFeedback: this.handleRequestShowDetail,
          },
        };
      },
    };
  }

  getFeedbackStatusColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'feedback_status_label',
      enablePivot: false,
      enableRowGroup: true,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
        field: 'feedback_status_label',
      },
      // valueGetter: this.getPricePositionValue,
    };
  }

  getOutcomeReasonValue(params) {
    const { colDef: { field, isClient } } = params;
    if (field && params.data && params.data[field]) {
      const a = map(orderBy(filter(params.data[field], isClient ? { is_client: true } : { is_client: false, is_strongest: true }), ['impact', 'label'], ['asc', 'asc']), 'label');
      return a;
    }
    return null;
  }

  getFeedbackCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: FeedbackRenderer,
      params: {
        field: 'feedbacks',
        isClient: true,
        mode: MODE_FEEDBACKS,
        requestShowFeedback: this.handleRequestShowDetail,
      },
    };
  }

  getFeedbacksColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'feedbacks',
      enablePivot: false,
      enableRowGroup: false,
      ...(column.auto_height ? { cellClass: 'cell-wrap-text' } : {}),
      autoHeight: column.auto_height,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
        field: 'feedbacks',
        isClient: true,
        requestShowInsight: this.handleRequestShowInsight,
      },
      valueGetter: this.getOutcomeReasonValue,
      cellRendererSelector: this.getFeedbackCellRendererSelector,
    };
  }

  

  getCompetitorValue(params) {
    const { colDef: { field } } = params;
    if (field && params.data && params.data[field]) {
      // const a = map(orderBy(filter(params.data[field], { is_client: false }), ['is_strongest'], ['desc']), 'vendor_name');
      // return a;
      const b = values(keyBy(params.data[field], 'value'));
      return map(b, 'name');
    }
    return [];
  }

  getCompetitorColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'strongest_competitors',
      enablePivot: false,
      enableRowGroup: true,
      ...(column.auto_height ? { cellClass: 'cell-wrap-text' } : {}),
      autoHeight: column.auto_height,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
        field: 'strongest_competitors',
      },
      valueGetter: this.getCompetitorValue,
      // keyCreator: this.competitorKeyCreator,
      // comparator: this.competitorComparator,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: CompetitorRenderer,
          params: {
            field: 'strongest_competitors',
          },
        };
      },
    };
  }

  getCompetitorOutcomeCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: FeedbackRenderer,
      params: {
        field: 'feedbacks',
        isClient: false,
        mode: MODE_FEEDBACKS,
        requestShowFeedback: this.handleRequestShowDetail,
      },
    };
  }

  getCompetitorOutcomeColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'feedbacks',
      enablePivot: false,
      enableRowGroup: false,
      ...(column.auto_height ? { cellClass: 'cell-wrap-text' } : {}),
      autoHeight: column.auto_height,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
        field: 'feedbacks',
        isClient: false,
        requestShowInsight: this.handleRequestShowInsight,
      },
      valueGetter: this.getOutcomeReasonValue,
      cellRendererSelector: this.getCompetitorOutcomeCellRendererSelector,
    };
  }

  getFeedbackDateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: column.target_field,
      enablePivot: false,
      enableRowGroup: true,
      type: 'dateColumn',
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: PublishDateRenderer,
          params: {
            field: column.target_field,
            column,
          },
        };
      },
      keyCreator: this.feedbackDateKeyCreator,
      valueFormatter: this.feedbackValueFormatter,
    };
  }

  getExcludedReasonColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: column.target_field,
      enablePivot: false,
      enableRowGroup: false,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      valueGetter: this.getExcluedReasonValue,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
    };
  }

  getContactCountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'contact_count',
      type: 'numericColumn',
      enableValue: true,
      allowedAggFuncs: ['sum', 'min', 'max', 'avg'],
      cellRendererParams: {
        column,
      },
    };
  }

  getRequestedFeedbackColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      // field: column.target_field,
      field: 'requested_feedbacks',
      cellRenderer: 'requestedFeedbackRenderer',
      cellRendererParams: {
        column,
      },
    };
  }

  getColDefs() {
    const { tableColumns, showExcluedReason } = this.props;

    const allColumns = reduce(tableColumns, (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'account') {
        column = this.getAccountColumn(tableColumn);
      } else if (tableColumn.tag === 'opportunityName') {
        column = this.getNameColumn(tableColumn);
      } else if (tableColumn.tag === 'stage') {
        column = this.getStageColumn(tableColumn);
      } else if (tableColumn.tag === 'amount') {
        column = this.getAmountColumn(tableColumn);
      } else if (tableColumn.tag === 'closeDate') {
        column = this.getCloseDateColumn(tableColumn);
      } else if (tableColumn.tag === 'feedbacks') {
        column = this.getFeedbacksColumn(tableColumn);
      } else if (tableColumn.tag === 'surveys') {
        column = this.getRequestedFeedbackColumn(tableColumn);
      } else if (tableColumn.tag === 'competitors') {
        column = this.getCompetitorColumn(tableColumn);
      } else if (tableColumn.tag === 'competitorOutcomes') {
        column = this.getCompetitorOutcomeColumn(tableColumn);
      } else if (tableColumn.tag === 'feedbackDate') {
        column = this.getFeedbackDateColumn(tableColumn);
      } else if (tableColumn.tag === 'contactCount') {
        column = this.getContactCountColumn(tableColumn);
      } else if (tableColumn.tag === 'pricePosition') {
        column = this.getPricePositionColumn(tableColumn);
      } else if (tableColumn.tag === 'feedbackStatus') {
        column = this.getFeedbackStatusColumn(tableColumn);
      } else if (tableColumn.tag === 'opportunityOwner' || (tableColumn.target_object === 'Opportunity' && tableColumn.target_field === 'owner_id')) {
        column = this.getOwnerColumn(tableColumn, false);
      } else if (tableColumn.tag === 'accountOwner' || (tableColumn.target_object === 'Account' && tableColumn.target_field === 'owner_id')) {
        column = this.getOwnerColumn(tableColumn, true);
      } else if (tableColumn.tag === 'excludedReason') {
        if (showExcluedReason) {
          column = this.getExcludedReasonColumn(tableColumn);
        }
      } else if (tableColumn.target_object === 'Opportunity' && tableColumn.target_field === 'requested_feedbacks') {
        column = this.getRequestedFeedbackColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: CUSTOM_FIELD_TYPES.OPPORTUNITY,
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);

    const ownerColumn = {
      colId: OWNER_COLUMN,
      headerName: OWNER_COLUMN,
      field: 'owner_id',
      hide: true,
      enablePivot: false,
      enableRowGroup: false,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filter: 'agTextColumnFilter',
    };
    allColumns.push(ownerColumn);

    each(EXTRA_FIELDS, (extraField) => {
      allColumns.push({
        colId: extraField.id,
        headerName: extraField.id,
        field: extraField.field,
        hide: true,
        enablePivot: false,
        enableRowGroup: false,
        suppressFiltersToolPanel: true,
        suppressColumnsToolPanel: true,
        filter: 'agSetColumnFilter',
        cellRendererParams: {
          isPrivate: true,
        },
      });
    });

    return allColumns;
  }

  getOutcomeValue(params) {
    if (params.data) {
      return {
        stage: params.data.stage,
        closeDate: params.data.close_date,
        outcome: params.data.outcome,
      };
    }
    return null;
  }

  getRightControls() {
    const { expandedRows } = this.state;
    if (expandedRows === 0) {
      return null;
    }
    return (
      <Button className="animated flash" bsStyle="link" onClick={this.collapseAll}>
        <span className="text-active"><Fa name="eject" /> Collapse <NumberDisplay value={expandedRows} suffix="row" suffixIsUnit precision={0} /></span>
      </Button>
    );
  }

  setOwnerFilter(value) {
    if (this.gridApi) {
      const ownerFilter = this.gridApi.getFilterInstance(OWNER_COLUMN);
      if (ownerFilter) {
        if (value) {
          // ownerFilter.selectNothing();
          // ownerFilter.selectValue(value);
          ownerFilter.setModel({
            filterType: 'text',
            type: 'equals',
            filter: value,
          });

        } else {
          // ownerFilter.selectEverything();
          ownerFilter.setModel(null);
        }
        this.gridApi.onFilterChanged();
      }
    }
  }

  pricePositionKeyCreator(params) {
    const { value } = params;
    return value && value.length ? value.join(', ') : 'N/A';
  }

  feedbackDateKeyCreator(params) {
    const vals = params.value;
    if (!vals) {
      return '--';
    }
    const format = 'Y MM';
    const m = moment(vals);
    return m.isValid() ? m.format(format) : '--';
  }

  convertPulishDate(input) {
    const format = 'Y MM';
    const displayFormat = 'MMMM Y';
    const m = moment(`${input}`, format);
    return m.isValid() ? m.format(displayFormat) : '--';
  }

  feedbackValueFormatter(params) {
    if (params.value) {
      return this.convertPulishDate(params.value);
    }
    return params.value;
  }

  competitorKeyCreator(params) {
    const { value } = params;
    const a = orderBy(filter(value, { is_strongest: true }), ['vendor_name'], ['asc']);
    return a.length ? map(a, 'vendor_name').join(', ') : 'N/A';
  }

  competitorComparator(value1, value2) {
    const a1 = orderBy(filter(value1, { is_strongest: true }), ['vendor_name'], ['asc']);
    const a2 = orderBy(filter(value2, { is_strongest: true }), ['vendor_name'], ['asc']);

    if (a1.length === 0 && a2.length === 0) {
      return 0;
    }
    if (a1.length === 0) {
      return -1;
    }
    if (a2.length === 0) {
      return 1;
    }
    const str1 = map(a1, 'vendor_name').join(', ');
    const str2 = map(a2, 'vendor_name').join(', ');
    return str1.localeCompare(str2);
  }

  outcomeComparator(value1, value2) {
    const date1Number = value1 ? value1.outcome : null;
    const date2Number = value2 ? value2.outcome : null;
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  }

  outcomeKeyCreator(params) {
    const { value } = params;
    const { stage, closeDate } = value;
    if (closeDate) {
      return `${stage} on ${closeDate.format('MMM DD, YYYY')}`;
    }
    return null;
  }

  footerValueGetter(params) {
    const { value, node: { level, field } } = params;
    if (level === -1) {
      return 'Grand Total';
    }

    let display = value;
    if (field === 'publish_date') {
      display = this.convertPulishDate(value);
    }
    return `Total ${display}`;
  }

  toggleShowAllDeals() {
    const {
      auth,
    } = this.props;
    const { showAllDeals } = this.state;
    this.setState({ showAllDeals: !showAllDeals }, () => {
      const userId = this.state.showAllDeals ? null : auth.user_id;
      this.setOwnerFilter(userId);
    });
  }

  applyFilters(opportunityFilters, force = false) {
    if (this.gridApi && opportunityFilters) {
      const { hashedFilters } = this.state;
      const newHasedFilters = hashObject(opportunityFilters);
      if (force || hashedFilters !== newHasedFilters) {
        this.setState({ hashedFilters: newHasedFilters }, () => {
          each(EXTRA_FIELDS, (extraField) => {
            const columnFilter = this.gridApi.getFilterInstance(extraField.id);
            if (columnFilter) {
              const value = opportunityFilters[extraField.field];
              if (value) {
                columnFilter.selectNothing();
                columnFilter.selectValue(value);
              } else {
                // columnFilter.selectEverything();
              }
            }
          });
          this.gridApi.onFilterChanged();
        });
      }
    }
  }

  reaplyFilters() {
    this.applyFilters(this.props.opportunityFilters, true);
  }

  collapseAll() {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        node.setExpanded(false);
      });
      this.setState({ detailModes: {} });
    }
  }

  handleGroupExpandedOrCollapsed() {
    if (this.gridApi) {
      let expandedRows = 0;
      this.gridApi.forEachNode((node) => {
        if (node.expanded) {
          expandedRows += 1;
        }
      });
      this.setState({ expandedRows });
    }
  }


  handleRequestShowDetail(mode, data, expand) {
    if (NESTED_MODE) {
      if (this.gridApi) {
        const { detailModes } = this.state;
        const currentMode = detailModes[data.opportunity_id];
        this.gridApi.forEachNode((node) => {
          const nodeData = node.data;
          if (nodeData) {
            if (nodeData.opportunity_id === data.opportunity_id) {
              if (currentMode !== mode && node.expand) {
                node.setExpanded(false); // close it first, force reload
              }
              const newDetailModes = { ...detailModes, [nodeData.opportunity_id]: expand ? mode : null };
              this.setState({ detailModes: newDetailModes }, () => {
                node.setExpanded(expand);
                // this.gridApi.refreshCells({ force: true });
              });
            }
          }
        });
      }
    } else {
      this.setState({
        detailModal: expand ? {
          mode,
          opportunity: data,
        } : null,
      });
    }
  }

  handleRequestShowInsight(opportunityId, insightId) {
    this.props.dispatch(fetchInsights(opportunityId, insightId));
  }

  hanldeRequestAddOpportunitySurvey(opportunity) {
    this.props.dispatch(requestEditWinLossOpportunityFeedbacks(opportunity));
  }

  hanldeRequestShowEmail(data) {
    this.props.dispatch(requestShowSurveyEmail(data));
  }

  handleOnSubmitContacts(opportunity, feedbacks, surveys) {
    if (NESTED_MODE) {
      if (surveys && surveys.length) {
        this.handleRequestShowDetail(MODE_SURVEYS, opportunity, true);
      }
      if (this.gridApi) {
        this.gridApi.forEachNode((node) => {
          const nodeData = node.data;
          if (nodeData && nodeData.opportunity_id === opportunity.opportunity_id) {
            this.gridApi.ensureIndexVisible(node.rowIndex);
          }
        });
      }
    }
    this.setState({ hashedFilters: null }, () => {
      this.applyFilters(this.props.opportunityFilters);
      this.gridApi.refreshCells({ force: true });
    });
  }
  
  handleSubmitContactAndDone(opportunity) {
    if (!NESTED_MODE) {
      this.handleRequestShowDetail(MODE_SURVEYS, opportunity, true);
    }
  }

  renderManagerFilter() {
    const { isManager } = this.props;
    const { showAllDeals } = this.state;
    if (!isManager) {
      return null;
    }
    return (
      <span>
        Show&nbsp;
        <Toggle
          onClick={this.toggleShowAllDeals}
          on={<span>All Deals</span>}
          off={<span>My Deals</span>}
          size="xs"
          onstyle="success"
          active={showAllDeals}
        />
      </span>
    );
  }


  render() {
    const {
      opportunities,
    } = this.props;

    if (opportunities.length === 0) {
      return (
        <div className="alert alert-danger">
          No Records Found.
        </div>
      );
    }
    const columnDefs = this.getColDefs();
    return (
      <div>
        <ModalDetail
          opportunity={this.state.detailModal.opportunity}
          mode={this.state.detailModal.mode}
          requestShowInsight={this.handleRequestShowInsight}
          requestAddOpportunitySurvey={this.hanldeRequestAddOpportunitySurvey}
          requestShowEmail={this.hanldeRequestShowEmail}
          onClose={() => { this.setState({ detailModal: {} }); }}
        />
        <GodTable
          id={this.props.tableName}
          columnDefs={columnDefs}
          rowData={opportunities}
          onGridReady={this.onGridReady}
          onColumnResized={this.onColumnResized}
          onColumnVisible={this.reaplyFilters}
          onColumnMoved={this.reaplyFilters}
          context={{
            detailModes: this.state.detailModes,
          }}
          components={{
            detailRenderer: DetailRenderer,
          }}
          onRowGroupOpened={this.handleGroupExpandedOrCollapsed}
          columnTypes={{
            dateColumn: {
              filter: 'agDateColumnFilter',
              filterParams: {
                comparator: dateComparator,
              },
            },
          }}
          leftControls={this.renderManagerFilter()}
          enableFullScreen
          fullScreenMode={this.props.fullScreenMode}
          onExitFullScreen={this.props.onExitFullScreen}
          onEnterFullScreen={this.props.onEnterFullScreen}
          fullScreenOffset={this.props.fullScreenOffset}
          tableManageConfigs={{
            enableCustomMeta: true,
            validCustomMetaObjects: ['Opportunity'],
          }}
          resourceType={GodTable.RESOURCE_TYPE.OPPORTUNITY}
          masterDetail={false}
          detailCellRenderer="detailRenderer"
          detailCellRendererParams={{
            requestShowInsight: this.handleRequestShowInsight,
            requestAddOpportunitySurvey: this.hanldeRequestAddOpportunitySurvey,
            requestShowEmail: this.hanldeRequestShowEmail,
          }}
          detailRowHeight={24}
          autoGroupColumnDef={{
            cellRendererParams: {
              footerValueGetter: this.footerValueGetter,
            },
          }}
          rightControls={this.getRightControls()}
        />
      </div>
    );
  }
}

OpportunityTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  isManager: PropTypes.bool,
  auth: PropTypes.shape({}),
  tableColumns: PropTypes.arrayOf(PropTypes.shape({})),
  fullScreenMode: PropTypes.bool,
  onExitFullScreen: PropTypes.func,
  onEnterFullScreen: PropTypes.func,
  tableName: PropTypes.string.isRequired,
  feedbackLoaded: PropTypes.bool,
  fullScreenOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  showExcluedReason: PropTypes.bool,
  opportunityFilters: PropTypes.shape({}),
  collectorStats: PropTypes.shape({}),
};
OpportunityTable.defaultProps = {
  opportunities: [],
  isManager: false,
  auth: null,
  tableColumns: [],
  fullScreenMode: false,
  onExitFullScreen: () => {},
  onEnterFullScreen: () => {},
  feedbackLoaded: false,
  fullScreenOffset: { x: 0, y: 0 },
  opportunityFilters: null,
  collectorStats: {},
  showExcluedReason: false,
};
OpportunityTable.contextTypes = {
};


// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    auth: getUser(state),
    tableColumns: getTablePreference(state, ownProps.tableName),
    collectorStats: getWinLossCollectorStats(state),
  };
}

export default connect(mapStateToProps)(OpportunityTable);
